// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__26qrB","rootCenter":"LoadMoreObserver_rootCenter__2dv8a","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__PXW31"};